import React from 'react';
import { useTranslation } from 'react-i18next';
import { UseCases } from '../homepage/UseCases';
import { Footer } from '../homepage/Footer';
import { PageSeo } from '../seo/PageSeo';
import { breadcrumbSchema } from '../seo/schemas';
import { CommonMessages } from '../../i18n/Common.messages';
import { UseCasesPageMessages, UseCasesPageText } from './UseCasesPage.messages';
import '../pages/static-page.css';

export const UseCasesPage: React.FC = () => {
  const { t } = useTranslation();

  return (
  <>
    <PageSeo
      path="/use-cases"
      localized
      titleKey="seo.useCases.title"
      descriptionKey="seo.useCases.description"
      ogImage="/og/og-default.png"
      keywords={['react i18n', 'next.js i18n', 'vue i18n', 'mobile localization', 'saas localization']}
      jsonLd={[
        breadcrumbSchema([
          { name: t(CommonMessages.BREADCRUMB_HOME), path: '/' },
          { name: t(UseCasesPageMessages.BREADCRUMB, { defaultValue: UseCasesPageText.BREADCRUMB }), path: '/use-cases' },
        ]),
      ]}
    />
    <div className="page-wrapper">
      <div style={{ paddingTop: '40px' }}>
        {/* Here the section title *is* the page title; see UseCases' headingLevel. */}
        <UseCases headingLevel={1} />
      </div>
      <Footer />
    </div>
  </>
  );
};
